import { uniqueByProp } from 'src/utils/misc/index';
import {
  GET_NOTIFICATIONS_REQUEST,
  GET_NOTIFICATIONS_SUCCESS,
  GET_NOTIFICATIONS_FAILURE,
  RECEIVED_NOTIFICATION,
  SHARE_AUDIENCE_REQUEST,
  SHARE_AUDIENCE_SUCCESS,
  SHARE_AUDIENCE_FAILURE,
  DELETE_NOTIFICATION_REQUEST,
  DELETE_NOTIFICATION_SUCCESS,
  DELETE_NOTIFICATION_FAILURE,
  MARK_ALL_NOTIFICATIONS_AS_READ_REQUEST,
  MARK_ALL_NOTIFICATIONS_AS_READ_SUCCESS,
  MARK_ALL_NOTIFICATIONS_AS_READ_FAILURE,
  MARK_NOTIFICATION_AS_READ_REQUEST,
  MARK_NOTIFICATION_AS_READ_SUCCESS,
  MARK_NOTIFICATION_AS_READ_FAILURE,
} from '../../constants/action-types';

const getInitialState = () => {
  return {
    isDataLoading: false,
    isShareLoading: false,
    data: [],
    error: false,
    message: null,
  };
};

const initialState = getInitialState();

const shareQuery = (state = initialState, action) => {
  const types = {
    [GET_NOTIFICATIONS_REQUEST]: () => ({
      ...state,
      isDataLoading: true,
      isShareLoading: false,
    }),
    [GET_NOTIFICATIONS_SUCCESS]: () => ({
      ...state,
      isDataLoading: false,
      isShareLoading: false,
      data: uniqueByProp(
        [...action.response, ...state.data],
        'id'
      ).sort((a, b) => (a.notify_date > b.notify_date ? -1 : 1)),
      error: false,
      message: null,
    }),
    [RECEIVED_NOTIFICATION]: () => ({
      ...state,
      data: [action.response, ...state.data],
    }),
    [GET_NOTIFICATIONS_FAILURE]: () => ({
      ...state,
      isDataLoading: false,
      isShareLoading: false,
      error: true,
      message: action.message,
    }),
    [SHARE_AUDIENCE_REQUEST]: () => ({
      ...state,
      isDataLoading: false,
      isShareLoading: true,
    }),
    [SHARE_AUDIENCE_SUCCESS]: () => ({
      ...state,
      isDataLoading: false,
      isShareLoading: false,
      error: false,
      message: null,
    }),
    [SHARE_AUDIENCE_FAILURE]: () => ({
      ...state,
      isDataLoading: false,
      isShareLoading: false,
      error: true,
      message: action.message,
    }),
    [DELETE_NOTIFICATION_REQUEST]: () => ({
      ...state,
      isDataLoading: true,
      isShareLoading: false,
    }),
    [DELETE_NOTIFICATION_SUCCESS]: () => ({
      ...state,
      isDataLoading: false,
      isShareLoading: false,
      error: false,
      message: null,
    }),
    [DELETE_NOTIFICATION_FAILURE]: () => ({
      ...state,
      isDataLoading: false,
      isShareLoading: false,
      error: true,
      message: action.message,
    }),
    [MARK_ALL_NOTIFICATIONS_AS_READ_REQUEST]: () => ({
      ...state,
      isDataLoading: true,
      isShareLoading: false,
    }),
    [MARK_ALL_NOTIFICATIONS_AS_READ_SUCCESS]: () => ({
      ...state,
      isDataLoading: false,
      isShareLoading: false,
      error: false,
      message: null,
    }),
    [MARK_ALL_NOTIFICATIONS_AS_READ_FAILURE]: () => ({
      ...state,
      isDataLoading: false,
      isShareLoading: false,
      error: true,
      message: action.message,
    }),
    [MARK_NOTIFICATION_AS_READ_REQUEST]: () => ({
      ...state,
      isDataLoading: true,
      isShareLoading: false,
    }),
    [MARK_NOTIFICATION_AS_READ_SUCCESS]: () => ({
      ...state,
      isDataLoading: false,
      isShareLoading: false,
      error: false,
      message: null,
    }),
    [MARK_NOTIFICATION_AS_READ_FAILURE]: () => ({
      ...state,
      isDataLoading: false,
      isShareLoading: false,
      error: true,
      message: action.message,
    }),
  };

  if (!types[action.type]) {
    return state;
  }

  return types[action.type]();
};

export default shareQuery;
